import { useContext } from "react";

import T from "./Translations";
import TranslationButton from "./TranslationButton";

import { GlobalContext } from "../ContextProvider";

import "../../styles/TranslationButton.scss";

const TranslationButtonGroup = () => {
    const { dispatch } = useContext(GlobalContext);

    return (
        <section className="translation-buttons-container-main">
            <div className="button-container">
                <TranslationButton
                    label="English"
                    onClick={() => {
                        dispatch({
                            type: "Lang",
                            lang: "en"
                        });
                    }}
                />
                <TranslationButton
                    label="Español"
                    onClick={() => {
                        dispatch({
                            type: "Lang",
                            lang: "es"
                        });
                    }}
                />
                <TranslationButton
                    label="普通話"
                    onClick={() => {
                        dispatch({
                            type: "Lang",
                            lang: "zh"
                        });
                    }}
                />
                <TranslationButton
                    label="Русский"
                    onClick={() => {
                        dispatch({
                            type: "Lang",
                            lang: "ru"
                        });
                    }}
                />
            </div>
            <div className="experimental-text">*{T({ key: "Breadcrumb_Translations" })}</div>
        </section>
    );
};

export default TranslationButtonGroup;
